export default __webpack_public_path__ + "static/media/Countdown-Sound.67c65e7d.mp3";